import { AppUpdateProvider } from "@/app/pwa/AppUpdateProvider";
import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { useAdminTitleRefresh } from "@/features/auth";
import { router } from "@/app/router";
import { PwaUpdatePrompt } from "@/app/pwa";
import { useAuth } from "@/features/auth";

/** Owns the lifetime and ordering of process-wide React providers. */
export function AppProviders({ queryClient }: { queryClient: QueryClient }) {
  const { generation } = useAuth();

  return (
    <QueryClientProvider client={queryClient}>
      <AppUpdateProvider>
        <AdminTitleRefresh />
        {/* Remount observers/forms on identity changes; the router retains the location. */}
        <RouterProvider key={generation} router={router} />
        {/* The browser's worker lifecycle survives account and school transitions. */}
        <PwaUpdatePrompt />
      </AppUpdateProvider>
    </QueryClientProvider>
  );
}

/** Query observers must mount inside the shared cache provider. */
function AdminTitleRefresh() {
  useAdminTitleRefresh();
  return null;
}
